export default {
  "raidActive": "Active",
  "raidDegraded": "Degraded",
  "raidRebuilding": "Rebuilding",
  "raidInactive": "Inactive",
  "raidUnknown": "Unknown",
  "raidSpare": "Spare",
  "raidFaulty": "Faulty",
  "raidRemoved": "Removed",
  "raidHealthy": "Healthy",
  "raidWarning": "Warning",
  "raidCritical": "Critical",
  "raidRecovery": "Recovery",
  "raidSpeed": "Speed:",
  "raidETA": "ETA:",
  "raidSMARTFAILED": "SMART FAILED",
  "raidSMARTOK": "SMART OK",
  "raidInstallSmartmontools": "Install smartmontools?",
  "raidThisWillInstallTheSmartmontoolsPackageViaAptFor": "This will install the smartmontools package via apt for SMART disk health monitoring.",
  "raidInstall": "Install",
  "raidCancel": "Cancel",
  "raidFailedToInstallSmartmontools": "Failed to install smartmontools",
  "raidSmartmontoolsInstalled": "smartmontools installed",
  "raidSMARTHealthDataWillAppearOnTheNextMonitoring": "SMART health data will appear on the next monitoring cycle.",
  "raidUnableToInstallSmartmontools": "Unable to install smartmontools",
  "raidInstalling": "Installing…",
  "raidSoftwareRAIDStatus": "Software RAID status",
  "raidSoftwareRAID": "Software RAID",
  "hardwareHardwareHealth": "Hardware health",
  "hardwareHardwareHealth2": "Hardware Health",
  "hardwareSampled": "sampled ",
  "hardwareNotYetSampled": "not yet sampled",
  "storeClearTelemetryHistory": "Clear telemetry history",
  "storeThisPermanentlyDeletesAllStoredSystemMetricsHistoryLive": "This permanently deletes all stored system-metrics history. Live charts keep updating, but the historical ranges will be empty until new data accumulates. This cannot be undone.",
  "storeClearHistory": "Clear history",
  "storeUnableToClearMetricsHistory": "Unable to clear metrics history.",
  "storeLoading": "Loading",
  "storeEmpty": "Empty",
  "storeIdle": "Idle",
  "storeTelemetryHistoryStore": "Telemetry History Store",
  "storeDurableSystemMetricsDatabaseBackingTheHistoryCharts": "Durable system-metrics database backing the history charts",
  "storeLiveUpdated": "Live · updated",
  "storeRefreshStoreSummary": "Refresh store summary",
  "storeTotalRows": "Total rows",
  "storeOnDisk": "On disk",
  "storeTiers": "Tiers",
  "storeStatus": "Status",
  "storeLoadingStoreSummary": "Loading store summary…",
  "storeNoTelemetryHistoryStoredYetDataAccumulatesAsThe": "No telemetry history stored yet. Data accumulates as the dashboard runs.",
  "metricCPU": "CPU",
  "metricCPUHistoryChart": "CPU history chart",
  "metricMemory": "Memory",
  "metricMemoryHistoryChart": "Memory history chart",
  "metricNetwork": "Network",
  "metricNetworkHistoryChart": "Network history chart",
  "metricDisk": "Disk",
  "metricDiskUsageTile": "Disk usage tile",
  "metricDiskIO": "Disk I/O",
  "metricTransferCorrelationChart": "Transfer correlation chart",
  "metricLoadAverage": "Load average",
  "metricMonitorAlerts": "Monitor alerts",
  "metricSwap": "Swap",
  "metricGPU": "GPU",
  "metricStreamingDashboard": "Streaming Dashboard",
  "metricGPUIsOnlySampledWhileTheStreamingDashboardIs": "GPU is only sampled while the Streaming Dashboard is open or a hardware-accelerated stream is active, so history is intermittent.",
  "metricTemperature": "Temperature",
  "metricCPUHealthCard": "CPU health card",
  "metricRaw": "Raw",
  "metricForever": "Forever",
  "metricNoData": "No data",
  "metricLive": "Live",
  "metricDelayed": "Delayed",
  "metricStale": "Stale",
  "metricLastSample": "Last sample",
  "metricNoHistoryStoredYet": "No history stored yet",
  "metricNoHistoryYet": "No history yet",
  "metricRes": "Res",
  "metricKeep": "Keep",
  "metricRows": "Rows",
  "metricNewest": "Newest",
  "transferInterInstanceTransfers": "Inter-Instance Transfers",
  "transferLiveSenderReceiverActivityForThisNode": "Live sender→receiver activity for this node",
  "transferOpenTheFullInterInstanceTransfersPage": "Open the full Inter-Instance Transfers page",
  "transferTransfersPage": "Transfers page",
  "transferReconnecting": "Reconnecting…",
  "transferAggregateSpeed": "Aggregate speed",
  "transferMovedInFlight": "Moved in flight",
  "transferLiveFeedUnavailable": "Live feed unavailable",
  "transferRetry": "Retry",
  "transferNoActiveTransfers": "No active transfers",
  "transferInboundAndOutboundTransfersAppearHereInRealTime": "Inbound and outbound transfers appear here in real time while they run.",
  "transferUser": "User",
  "transferDirection": "Direction",
  "transferPeer": "Peer",
  "transferSize": "Size",
  "transferFiles": "Files",
  "transferElapsed": "Elapsed",
  "transferAvg": "Avg",
  "transferMapSending": "Sending →",
  "transferMapReceiving": "← Receiving",
  "transferMapClickAHighlightedServerToOpenItsDashboard": "Click a highlighted server to open its dashboard",
  "transferMapSending2": "Sending",
  "transferMapReceiving2": "Receiving",
  "transferMapThisNode": "This node",
  "transferMapClickToOpenThisServerRsquoSDashboard": "Click to open this server’s dashboard",
  "securityLiveUpdatingEvery12s": "Live — updating every 12s",
  "securityLiveStreamActive": "Live stream active",
  "securityConnecting": "Connecting",
  "security24h": "24h",
  "security7d": "7d",
  "security30d": "30d",
  "securityTimeWindow": "Time window",
  "securitySearchIPCountryOrJail": "Search IP, country, or jail…",
  "securitySearchActiveBans": "Search active bans",
  "securityClearSearch": "Clear search",
  "securityNoActiveBansRightNow": "No active bans right now.",
  "securityCurrentlyBannedIPAddresses": "Currently banned IP addresses",
  "securityIP": "IP",
  "securityCountry": "Country",
  "securityJail": "Jail",
  "securityBanned": "Banned",
  "securityNoBansRecordedInThisWindow": "No bans recorded in this window.",
  "securityFilterCountry": "Filter country…",
  "securityFilterCountries": "Filter countries",
  "securityCountries": "countries •",
  "securityCountryPagination": "Country pagination",
  "securityPreviousPage": "Previous page",
  "securityNextPage": "Next page",
  "securityNoIPsRecordedInThisWindow": "No IPs recorded in this window.",
  "securitySearchIPJailOrCountry": "Search IP, jail or country…",
  "securitySearchTopBlockedIPs": "Search top blocked IPs",
  "securityTopBlockedIPAddressesByBanCount": "Top blocked IP addresses by ban count",
  "securityBans": "Bans",
  "securityIPs": "IPs",
  "securityTopIPsPagination": "Top IPs pagination",
  "securityTotal": "Total",
  "securityNoJailDataInThisWindow": "No jail data in this window.",
  "securityNoBanEventsInThisWindow": "No ban events in this window.",
  "securityPeak": "Peak",
  "securityFail2banServiceIsNotRunning": "fail2ban service is not running",
  "securityBanMetricsAreUnavailableStartTheServiceToResume": "Ban metrics are unavailable. Start the service to resume protection.",
  "securityFail2BanProtection": "Fail2Ban Protection",
  "securityActiveBansAndBlockedSources": "Active bans and blocked sources",
  "securityConfigureFail2ban": "Configure fail2ban",
  "securityConfigure": "Configure",
  "securityPermanentRecord": "Permanent record",
  "securityAllTimeNeverResets": "· all-time, never resets",
  "securityOffendingIPsEverSeen": "Offending IPs ever seen",
  "securityDistinctAttackersAllTime": "distinct attackers, all-time",
  "securityDistinctIPsEverRecordedAsOffendersSourcedFromThe": "Distinct IPs ever recorded as offenders. Sourced from the permanent security event ledger — this count only ever goes up, even after bans expire or fail2ban restarts.",
  "securityPermanentBans": "Permanent bans",
  "securityActiveForeverBans1": "active permanent bans",
  "securityIPsWithAnActivePermanentBanBanTime1": "IPs with an active permanent ban (ban time -1). A permanent ban stays counted until an explicit unban is recorded — fail2ban purging its own state can never drop it.",
  "securityLiveAmpRecentActivity": "Live & recent activity",
  "securityLiveCountVs": "· live count vs",
  "securityWindow": "window",
  "securityBannedRightNow": "Banned right now",
  "securityLiveActiveThisInstant": "live — active this instant",
  "securityBansFail2banIsEnforcingAtThisInstantFromThe": "Bans fail2ban is enforcing at this instant, from the live service. This is a point-in-time count — it rises and falls as bans are added and expire, so it is expected to differ from the window and all-time figures.",
  "securityBusiestJail": "Busiest Jail",
  "securityDistinctAttackersInWindow": "distinct attackers in window",
  "securityDistinctAttackerIPsBannedInTheSelectedWindowFrom": "Distinct attacker IPs banned in the selected window, from the permanent security event ledger. An exact count of unique IPs across the real window — not ban events.",
  "securityActiveBansCurrentlyBannedIPAddresses": "Active bans — currently banned IP addresses",
  "securityActiveBansLive": "Active Bans (Live)",
  "securityCurrentlyBlockedIPsRealBanTimeServerSideSearch": "Currently blocked IPs — real ban-time, server-side search & paging",
  "securityBansByCountry": "Bans by Country",
  "securityDistinctIPs": "Distinct IPs ·",
  "securityLedger": "· ledger",
  "securityTopBlockedIPs": "Top Blocked IPs",
  "securityBanEventsPerIP": "Ban events per IP ·",
  "securityAccessVectorBreakdown": "Access-Vector Breakdown",
  "securityBansPerJailLive24hWindow": "Bans per jail • Live — 24h window",
  "securityClickAJailBarToNavigateToConfiguration": "Click a jail bar to navigate to configuration.",
  "securityBanEvents": "Ban Events",
  "securityTimeline": "Timeline —",
  "optimizationCPUOptimizationRules": "CPU Optimization Rules",
  "optimizationRunDiagnosticsOrManageAutomatedCPURules": "Run diagnostics or manage automated CPU rules.",
  "optimizationNoCPURulesConfiguredAddARuleToAutomate": "No CPU rules configured. Add a rule to automate CPU optimization.",
  "optimizationRunDiagnostics": "Run Diagnostics",
  "optimizationRunning": "Running...",
  "optimizationRunNow": "Run Now",
  "optimizationMemoryOptimizationRules": "Memory Optimization Rules",
  "optimizationRunManualOptimizationOrManageAutomatedRules": "Run manual optimization or manage automated rules.",
  "optimizationNoRulesConfiguredAddARuleToAutomateMemory": "No rules configured. Add a rule to automate memory optimization.",
  "optimizationOptimizing": "Optimizing...",
  "optimizationCloseModal": "Close modal",
  "optimizationAutoOptimizationRules": "Auto-Optimization Rules",
  "optimizationLoadingRules": "Loading rules",
  "optimizationAddRule": "Add Rule",
  "ruleMemory": "Memory %",
  "ruleSwap": "Swap %",
  "ruleDisk": "Disk %",
  "ruleLoad1m": "Load (1m)",
  "ruleSvcCPU": "Svc CPU %",
  "ruleOptimizeMemory": "Optimize Memory",
  "ruleNotify": "Notify",
  "ruleRestartService": "Restart Service",
  "ruleStopService": "Stop Service",
  "ruleNever": "Never",
  "ruleDanger": "danger",
  "ruleCooldown": "Cooldown:",
  "ruleLast": "Last:",
  "ruleEdit": "Edit",
  "ruleConfirm": "Confirm?",
  "ruleDelete": "Delete",
  "ruleTest": "Test",
  "ruleFormMemoryUsage": "Memory Usage %",
  "ruleFormCPUUsage": "CPU Usage %",
  "ruleFormSwapUsage": "Swap Usage %",
  "ruleFormDiskUsage": "Disk Usage %",
  "ruleFormLoadAverage1m": "Load Average (1m)",
  "ruleFormServiceCPU": "Service CPU %",
  "ruleFormStopServiceDanger": "Stop Service (Danger)",
  "ruleFormNameIsRequired": "Name is required",
  "ruleFormServiceNameIsRequiredForServiceScope": "Service name is required for service scope",
  "ruleFormInvalidServiceNameFormat": "Invalid service name format",
  "ruleFormThresholdMustBeAPositiveNumber": "Threshold must be a positive number",
  "ruleFormDurationMustBeANonNegativeNumber": "Duration must be a non-negative number",
  "ruleFormCooldownMustBeANonNegativeNumber": "Cooldown must be a non-negative number",
  "ruleFormDangerModeMustBeEnabledForStopServiceAction": "Danger mode must be enabled for Stop Service action",
  "ruleFormName": "Name",
  "ruleFormEGHighCPUAlert": "e.g. High CPU Alert",
  "ruleFormEGHighMemoryAlert": "e.g. High Memory Alert",
  "ruleFormScope": "Scope",
  "ruleFormSystemWide": "System-wide",
  "ruleFormServiceSpecific": "Service-specific",
  "ruleFormServiceName": "Service Name",
  "ruleFormEGSonarrUsernamePlexmediaserverUsername": "e.g. sonarr@username, plexmediaserver@username",
  "ruleFormSystemdUnitNameTypeToSearchInstalledAppsOr": "Systemd unit name. Type to search installed apps or enter a custom service.",
  "ruleFormCondition": "Condition",
  "ruleFormMetric": "Metric",
  "ruleFormComingSoon": " (coming soon)",
  "ruleFormOperator": "Operator",
  "ruleFormThresholdValue": "Threshold value",
  "ruleFormSustainedDurationSeconds": "Sustained Duration (seconds)",
  "ruleFormHowLongTheConditionMustPersistBeforeTriggering0": "How long the condition must persist before triggering. 0 = immediate.",
  "ruleFormAction": "Action",
  "ruleFormDangerMode": "Danger Mode",
  "ruleFormEnableDangerMode": "Enable danger mode",
  "ruleFormCooldownSeconds": "Cooldown (seconds)",
  "ruleFormMinimumTimeBetweenConsecutiveTriggers": "Minimum time between consecutive triggers.",
  "ruleFormSaving": "Saving...",
  "ruleFormUpdateRule": "Update Rule",
  "ruleFormCreateRule": "Create Rule",
  "stopRuleConfirmStopServiceRule": "Confirm Stop Service Rule",
  "stopRuleType": "Type",
  "stopRuleConfirmStopRule": "Confirm Stop Rule",
  "cpuColumnOffline": "offline",
  "cpuColumnMasked": "Masked",
  "cpuColumnMicrocode": "Microcode",
  "cpuColumnTheRunningRevisionIsMasked0xffffffffCommonUnderA": "The running revision is masked (0xffffffff) — common under a hypervisor",
  "cpuColumnRunningMicrocodeRevision": "Running microcode revision",
  "cpuColumnVulnerabilities": "Vulnerabilities",
  "cpuColumnMitigated": "mitigated",
  "cpuColumnVulnerable": "vulnerable",
  "cpuColumnUnknown": "unknown",
  "cpuColumnHideAffectedVulnerabilityNames": "Hide affected vulnerability names",
  "cpuColumnShowAffectedVulnerabilityNames": "Show affected vulnerability names",
  "cpuColumnThrottleEvents": "Throttle events",
  "cpuColumnNotExposed": "Not exposed",
  "cpuColumnLastSeen": "last seen",
  "cpuColumnBeforeTheDashboardStarted": "before the dashboard started",
  "cpuColumnSince": "· since",
  "cpuColumnUnableToRescanKernelFaults": "Unable to rescan kernel faults.",
  "cpuColumnKernelDumps": "Kernel dumps",
  "cpuColumnReRunTheKernelFaultProbeNow": "Re-run the kernel-fault probe now",
  "cpuColumnRescanKernelLogs": "Rescan kernel logs",
  "cpuColumnSince2": "since",
  "cpuColumnHistoryCleared": "History cleared",
  "cpuColumnDumpsDiscarded": "dumps discarded)",
  "cpuColumnModel": "Model",
  "cpuColumnCores": "Cores",
  "cpuColumnOnline": "online",
  "cpuColumnNoSensors": "No sensors",
  "cpuColumnFans": "Fans",
  "cpuPowerProfileModalPerformance": "Performance",
  "cpuPowerProfileModalBalanced": "Balanced",
  "cpuPowerProfileModalPowerSaver": "Power saver",
  "cpuPowerProfileModalClocksStayHighAndReadyFastestResponseMoreHeat": "Clocks stay high and ready — fastest response, more heat and power",
  "cpuPowerProfileModalScalesClocksWithLoadTheLinuxDefaultBestFor": "Scales clocks with load — the Linux default, best for most servers",
  "cpuPowerProfileModalLowestClocksAndHeatSlowestResponse": "Lowest clocks and heat — slowest response",
  "cpuPowerProfileModalTheKernelDefault": "the kernel default",
  "cpuPowerProfileModalNotOfferedByThisCPUSDriver": "Not offered by this CPU's driver",
  "cpuPowerProfileModalTheSettingThatLoadsAtBootDiffersFromWhat": "The setting that loads at boot differs from what is running now",
  "cpuPowerProfileModalLetsCoresBrieflyRunAboveTheirBaseClockWhen": "Lets cores briefly run above their base clock when there is thermal headroom",
  "cpuPowerProfileModalCustom": "Custom",
  "cpuPowerProfileModalNotSet": "not set",
  "cpuPowerProfileModalCPUPowerProfile": "CPU power profile",
  "cpuPowerProfileModalClose": "Close",
  "cpuPowerProfileModalNow": "Now:",
  "cpuPowerProfileModalAtBoot": "At boot:",
  "cpuPowerProfileModalManagedBy": "— managed by",
  "cpuPowerProfileModalPowerProfile": "Power profile",
  "cpuPowerProfileModalTurboBoost": "Turbo boost",
  "cpuPowerProfileModalApplying": "Applying…",
  "cpuPowerProfileModalApply": "Apply",
  "cpuPowerRowManagedByTheHypervisor": "Managed by the hypervisor",
  "cpuPowerRowNotAvailable": "Not available",
  "cpuPowerRowHowTheCPUGovernorAndTurboBoostAreSet": "How the CPU governor and turbo boost are set",
  "cpuPowerRowTheCPUGovernorAndTurboBoostThatAreRunning": "The CPU governor and turbo boost that are running now, and what loads at boot",
  "cpuPowerRowChangeCPUPowerProfile": "Change CPU power profile",
  "cpuPowerRowChange": "Change",
  "faultHistogramClearKernelDumpHistory": "Clear kernel dump history",
  "faultHistogramThisDeletesTheRotatedKernelLogsAndEmptiesThe": "This deletes the rotated kernel logs and empties the live kernel log on this server, so the dump history below starts from zero. Use it after a hardware repair or replacement, when the recorded faults no longer apply to this machine. This cannot be undone.",
  "faultHistogramUnableToClearTheKernelDumpHistory": "Unable to clear the kernel dump history.",
  "faultHistogramKernelFaults": "Kernel faults",
  "faultHistogramFrom": "from",
  "faultHistogramOldest": "oldest",
  "faultHistogramNewest": "newest",
  "faultHistogramScanned": "scanned",
  "faultHistogramClearDumpHistory": "Clear dump history",
  "faultHistogramMCELines": "MCE lines:",
  "faultHistogramEDACLines": "EDAC lines:",
  "faultHistogramThermalLines": "Thermal lines:",
  "memoryColumnVisibleTotal": "Visible total",
  "memoryColumnKernelVisibleRAMMemTotal": "Kernel-visible RAM (MemTotal)",
  "memoryColumnInstalled": "Installed",
  "memoryColumnSMBIOSInstalledCapacityVsKernelVisibleALargeGap": "SMBIOS-installed capacity vs kernel-visible; a large gap can mean a failed or hidden module",
  "memoryColumnCorrupted": "Corrupted",
  "memoryColumnHardwareCorruptedKernelQuarantinedMemoryPages": "HardwareCorrupted — kernel-quarantined memory pages",
  "memoryColumnECCFirmware": "ECC (firmware)",
  "memoryColumnNotReported": "Not reported",
  "memoryColumnWhatSMBIOSSaysTheBoardSupports": "What SMBIOS says the board supports",
  "memoryColumnECCCounters": "ECC counters",
  "memoryColumnLiveEDACCountersABoardCanReportECCWhile": "Live EDAC counters — a board can report ECC while the kernel has no driver for its controller, so counters are Not exposed",
  "memoryColumnDIMMTemperatures": "DIMM temperatures",
  "memoryColumnModules": "Modules",
  "memoryColumnHideDIMMInventory": "Hide DIMM inventory",
  "memoryColumnShowDIMMInventory": "Show DIMM inventory",
  "memoryColumnDIMMInventoryNeedsTheHardwareProbeHelper": "DIMM inventory needs the hardware probe helper",
  "noticesStripDismissThrottle": "Dismiss throttle",
  "noticesStripUnableToUpdateNotices": "Unable to update notices.",
  "noticesStripThrottleWarningDismissed": "Throttle warning dismissed",
  "noticesStripUnableToDismissTheThrottleWarning": "Unable to dismiss the throttle warning.",
  "noticesStripAllNoticesHidden": "All notices hidden",
  "noticesStripHide": "Hide",
  "noticesStripDismiss": "Dismiss",
  "noticesStripSelected": "selected",
  "noticesStripHideSelected": "Hide selected",
  "noticesStripDismissSelected": "Dismiss selected",
  "noticesStripClearSelection": "Clear selection",
  "noticesStripHiddenNotices2": "Hidden notices",
  "noticesStripRestoreAll": "Restore all",
  "noticesStripRestore": "Restore",
  "platformColumnUndetermined": "Undetermined",
  "platformColumnBareMetal": "Bare metal",
  "platformColumnPlatform": "Platform",
  "platformColumnSystemVendor": "System vendor",
  "platformColumnFamily": "Family",
  "platformColumnChassis": "Chassis",
  "platformColumnBoardVendor": "Board vendor",
  "platformColumnBoard": "Board",
  "platformColumnBoardRev": "Board rev",
  "platformColumnBIOS": "BIOS",
  "platformColumnFirmwareVendorAndVersionReportedBySMBIOS": "Firmware vendor and version reported by SMBIOS",
  "platformColumnBIOSDate": "BIOS date",
  "platformColumnFirmwareRelease": "Firmware release",
  "platformColumnSMBIOSBIOSRevision": "SMBIOS BIOS Revision",
  "productLabelRowProduct": "Product",
  "productLabelRowProductLabel": "Product label",
  "productLabelRowAddAProductLabel": "Add a product label",
  "productLabelRowEditProductLabel": "Edit product label",
  "writebackCardClear": "Clear",
  "writebackCardDrained": "Drained",
  "writebackCardLivelock": "Livelock",
  "writebackCardStillBusy": "Still busy",
  "writebackCardUnsupported": "Unsupported",
  "writebackCardReleaseUnreferencedInodes": "Release unreferenced inodes",
  "writebackCardThisDropsTheKernelSCachedCopyOfInodes": "This drops the kernel's cached copy of inodes that no process is using, to break a writeback livelock. Files that are open or in use are left untouched. A deeply stuck machine may still need a reboot. The release can take up to about 35 seconds.",
  "writebackCardReleaseInodes": "Release inodes",
  "writebackCardWritebackCleanup": "Writeback cleanup",
  "writebackCardReRunTheWritebackCheckNow": "Re-run the writeback check now",
  "writebackCardReCheckWritebackState": "Re-check writeback state",
  "writebackCardCheckingWritebackState": "Checking writeback state...",
  "writebackCardDyingCgroups": "Dying cgroups",
  "writebackCardCachedInodes": "Cached inodes",
  "writebackCardExt4InodeCache": "ext4 inode cache",
  "writebackCardCachedMemory": "Cached memory",
  "writebackCardAfterRelease": "After release",
  "writebackCardWorkerPeak": "Worker peak",
  "writebackCardDrainRate": "Drain rate",
  "writebackCardEstimatedTime": "Estimated time",
  "useFaultHistoryTheServerRejectedTheRequest": "The server rejected the request.",
  "useFaultHistoryNetworkError": "Network error",
  "useWritebackCheckTheServerCouldNotReadWritebackState": "The server could not read writeback state.",
  "maintenanceOK": "OK",
  "maintenanceFailed": "Failed",
  "maintenanceCancelled": "Cancelled",
  "maintenanceRunning": "Running",
  "maintenanceQueued": "Queued",
  "maintenanceCancelTask": "Cancel task",
  "maintenanceRunTaskNow": "Run task now",
  "maintenanceRunTask": "Run task",
  "maintenanceNoTasksReported": "No tasks reported",
  "maintenanceRunMaintenanceTask": "Run Maintenance Task",
  "maintenanceRun": "Run",
  "maintenanceNoStreamingServersConfigured": "No streaming servers configured",
  "maintenanceConnectEmbyJellyfinOrPlexToManageMaintenanceTasks": "Connect Emby, Jellyfin, or Plex to manage maintenance tasks here.",
  "maintenanceOpenSettings": "Open Settings",
  "useMetricsStoreUnableToLoadMetricsStoreSummary": "Unable to load metrics store summary.",
  "useMonitorRulesFailedToLoadMonitorRules": "Failed to load monitor rules",
  "useMonitorRulesFailedToCreateRule": "Failed to create rule",
  "useMonitorRulesRuleCreated": "Rule created",
  "useMonitorRulesFailedToUpdateRule": "Failed to update rule",
  "useMonitorRulesRuleUpdated": "Rule updated",
  "useMonitorRulesFailedToDeleteRule": "Failed to delete rule",
  "useMonitorRulesRuleDeleted": "Rule deleted",
  "useMonitorRulesFailedToToggleRule": "Failed to toggle rule",
  "useMonitorRulesFailedToTriggerRule": "Failed to trigger rule",
  "useMonitorRulesRuleTriggeredSuccessfully": "Rule triggered successfully",
  "useMonitorRulesCPUOptimizationFailed": "CPU optimization failed",
  "useMaintenanceTasksFailedToLoadMaintenanceTasks": "Failed to load maintenance tasks",
  "useMaintenanceTasksFailedToStartTask": "Failed to start task",
  "useMaintenanceTasksFailedToCancelTask": "Failed to cancel task",
  "useMaintenanceTasksFailedToStartLibraryScan": "Failed to start library scan",
  "useActiveTransfersLiveFeedDisconnected": "Live feed disconnected",
  "ruleCPU": "CPU %",
  "ruleImmediate": "immediate",
  "raidProgress": "{{action}} progress: {{percent}}%",
  "raidActionProgress": "{{action}} in progress",
  "raidReallocated": "Reallocated sectors: {{count}}",
  "raidPending": "Pending sectors: {{count}}",
  "httpError": "Server returned HTTP {{status}}",
  "raidInstallHint": "Install smartmontools to enable drive health monitoring",
  "raidActiveDisks": "Active disks: {{active}} / {{total}}",
  "raidSpareDisks": "Spare disks: {{count}}",
  "raidFailedDisks": "Failed disks: {{count}}",
  "raidMismatches": "Mismatches: {{count}}",
  "raidDetectedArrays": "Arrays detected: {{count}}",
  "storeCleared": "Telemetry history cleared. Rows removed: {{count}}",
  "metricAccessibleHistory": "{{metric}} store: {{status}}, {{span}} of history preserved",
  "metricAccessibleEmpty": "{{metric}} store: {{status}}, no history stored yet",
  "metricHistoryPreserved": "{{span}} of history preserved",
  "metricTowardLimit": "Toward {{limit}} retention limit",
  "metricPreserved": "{{span}} preserved",
  "metricRowsFeedsMessage": "Rows: {{count}} · feeds {{surface}}",
  "transferOpenPeer": "Opens {{name}}’s dashboard",
  "transferMapAccessible": "Live transfer map. Active transfers: {{count}}. Sending: {{sending}}. Receiving: {{receiving}}. Peer instances: {{peers}}.",
  "transferMapActiveCount": "Active transfers: {{count}}",
  "transferMapSendCount": "Sending: {{count}}",
  "transferMapReceiveCount": "Receiving: {{count}}",
  "transferMapOpenPeer": "Open {{name}}’s dashboard (opens in a new tab)",
  "ruleDisable": "Disable rule: {{name}}",
  "ruleEnable": "Enable rule: {{name}}",
  "ruleConfirmDelete": "Confirm delete rule: {{name}}",
  "ruleDeleteNamed": "Delete rule: {{name}}",
  "ruleCondition": "When {{metric}} {{operator}} {{threshold}} for {{duration}}, then {{action}}",
  "ruleFormStopWarning": "This rule automatically stops the service when triggered. Typed confirmation is required on save.",
  "maintenanceRunningCount": "Running tasks: {{count}}",
  "maintenanceTaskCount": "Tasks: {{count}}",
  "maintenanceConfirmRun": "Run “{{task}}” on {{server}} now? Some tasks may take a while and add load to the server.",
  "securityCountryShare": "{{name}} accounts for {{percent}}% of banned sources in this window",
  "securityPageOf": "Page {{page}} of {{total}}",
  "securityViewJail": "View {{jail}} jail configuration",
  "securityJailBans": "{{jail}} — bans: {{count}}",
  "securityJailChart": "Bans per jail bar chart. {{summary}}",
  "securityTimelineAccessible": "Ban event timeline over {{window}}. Total ban events: {{count}}.",
  "securityBansWindow": "Bans · {{window}}",
  "securityBansInWindow": "Bans ({{window}})",
  "securityWindowLabel": "{{label}} window",
  "securityRecentEvents": "Ban events in the last {{window}}",
  "securityWindowEventsHint": "Ban events recorded in the last {{window}} from the permanent security event ledger. This counts events in the window rather than currently active bans, so it differs from the live count.",
  "securityBusiestHint": "Jail with the most ban events in the last {{window}}, from the permanent security event ledger.",
  "securityUniqueWindow": "Unique IPs ({{window}})",
  "securityCountryHint": "Distinct offender IPs in each country over the last {{window}}, from the permanent security ledger. This counts unique IPs, so the number may differ from the ban-event total.",
  "securityTopHint": "Ban events per IP over the last {{window}}, from the permanent security ledger. An IP banned repeatedly counts each event, so this differs from the distinct-IP count by country.",
  "securityHistoricalJails": "Bans per jail • Historical — {{window}} window",
  "cpuOffline": "Offline logical CPUs: {{cpus}}",
  "cpuEarlyLoaded": "{{revision}} (early-loaded from {{previous}})",
  "cpuThrottleCounts": "Core: {{core}} / package: {{package}}",
  "cpuThrottleLifetime": "Since boot — core: {{core}} / package: {{package}}",
  "cpuHistoryCleared": "Kernel dump history cleared. Dumps discarded: {{count}}.",
  "memoryRank": "Rank {{rank}}",
  "memoryPopulated": "Populated: {{count}}",
  "memorySlots": "Populated: {{count}} / {{slots}}",
  "noticeSelect": "Select notice: {{message}}",
  "platformVirtualGuest": "Virtual guest ({{type}})",
  "productFirmware": "Firmware reports: {{name}}",
  "writebackPeakChange": "{{before}}% to {{after}}%",
  "writebackValueChange": "{{before}} to {{after}}",
  "noticesHiddenCount": "Notices hidden: {{count}}",
  "noticesDismissedCount": "Notices dismissed: {{count}}",
  "noticesRestoredCount": "Notices restored: {{count}}",
  "noticeEccUncorrectable": "Uncorrectable ECC errors reported by EDAC: {{count}}",
  "noticeMemoryHardwareCorrupted": "Memory marked hardware-corrupted by the kernel: {{kilobytes}} kB",
  "noticeTempAtCritical": "{{label}} at {{celsius}}°C meets or exceeds its critical threshold of {{threshold}}°C",
  "noticeTempHigh": "{{label}} at {{celsius}}°C meets or exceeds its maximum threshold of {{threshold}}°C",
  "noticeCoresOffline": "Logical CPUs offline: {{count}}",
  "noticeEccCorrectable": "Correctable ECC errors reported by EDAC: {{count}}",
  "noticeMemoryCapacityMismatch": "Installed memory exceeds kernel-visible memory by {{percent}}%",
  "noticeCpuVulnerable": "CPU vulnerability unmitigated: {{vulnerability}}",
  "noticeThermalThrottleActive": "Thermal throttling active. Events: {{count}}; window: {{minutes}} min",
  "noticeThermalThrottleHistory": "Throttle events since boot: {{count}}; last seen {{lastSeen}}",
  "noticeThermalThrottleHistoryBeforeDashboard": "Throttle events since boot: {{count}}; last seen before the dashboard started",
  "noticeMicrocodeVminMitigation": "CPU microcode predates Intel’s 0x12B Vmin-shift mitigation; update the BIOS or microcode package",
  "noticeMicrocodeUpdate12f": "Newer CPU microcode (0x12F) is available for this processor",
  "noticeMicrocodeCurrent": "CPU microcode is current; no advisory action needed",
  "noticeChipVirtual": "Virtual guest",
  "noticeChipVirtualHint": "Running under a hypervisor — some sensors and DMI fields are masked",
  "noticeChipNoTemps": "No temperature sensors",
  "noticeChipNoTempsHint": "No usable hwmon temperature source on this box",
  "noticeChipEccCounters": "ECC counters not exposed",
  "noticeChipEccCountersHint": "No EDAC memory-controller driver — live CE/UE counters are unavailable",
  "noticeChipNoDmi": "DMI probe unavailable",
  "noticeChipNoDmiHint": "The hardware probe helper is not installed — BIOS/board/DIMM detail is limited",
  "noticeChipNoThrottle": "No throttle counters",
  "noticeChipNoThrottleHint": "thermal_throttle is not exposed (Intel-only, and absent under a hypervisor)",
  "noticeCpuFaultDominantCurrentBoot": "CPU {{cpu}} appears in {{count}} of {{total}} kernel dumps ({{multiple}}× its expected share); {{sinceBoot}} since the current boot",
  "noticeCpuFaultDominantCurrentBootOops": "CPU {{cpu}} appears in {{count}} of {{total}} kernel dumps ({{multiple}}× its expected share); BUG/Oops lines logged: {{oopsCount}}; {{sinceBoot}} since the current boot",
  "noticeCpuFaultDominantPreviousBoot": "CPU {{cpu}} appears in {{count}} of {{total}} kernel dumps ({{multiple}}× its expected share); none since the current boot ({{bootDate}})",
  "noticeCpuFaultDominantPreviousBootOops": "CPU {{cpu}} appears in {{count}} of {{total}} kernel dumps ({{multiple}}× its expected share); BUG/Oops lines logged: {{oopsCount}}; none since the current boot ({{bootDate}})",
  "stopRuleWarning": "This rule automatically stops {{service}} when triggered. Stopping a service may cause downtime and affect dependent applications.",
  "stopRuleTypeName": "Type {{service}} to confirm",
  "transferStatusPreparing": "Preparing",
  "transferStatusPrepareFailed": "Preparation failed",
  "transferStatusProposed": "Awaiting approval",
  "transferStatusOffered": "Awaiting approval",
  "transferStatusCreated": "Awaiting approval",
  "transferStatusApproved": "Approved",
  "transferStatusGranted": "Ready",
  "transferStatusTransferring": "Transferring",
  "transferStatusVerifying": "Verifying",
  "transferStatusCompleted": "Completed",
  "transferStatusFailed": "Failed",
  "transferStatusCancelled": "Cancelled",
  "transferStatusRevoked": "Cancelled",
  "transferStatusRejected": "Declined",
  "transferStatusExpired": "Expired",
  "transferStatusPaused": "Paused",
  "securityAverageHour": "Avg/hour",
  "securityAverageDay": "Avg/day",
  "securityPerHour": "per hour",
  "securityPerDay": "per day",
  "securityBanCount": "Bans: {{count}}",
  "cpuTurboOn": " · Turbo on",
  "cpuTurboOff": " · Turbo off",
  "cpuThrottleActive": "Active events: {{count}}; window: {{minutes}} min",
  "labelValue": "{{label}}: {{value}}",
  "transferOffline": "Offline",
  "noticeHidden": "Hidden",
  "noticeDismissed": "Dismissed",
  "cpuNoDumpsSinceBoot": "No dumps since the current boot ({{date}})",
  "cpuDumpsSinceBoot": "Dumps since the current boot ({{date}}): {{count}}",
  "cpuDominantDumps": "CPU {{cpu}}: {{count}} / {{total}} dumps ({{percent}}%)",
  "cpuClearedHistory": "History cleared {{date}}; discarded dumps: {{count}}",
  "cpuTemperatureLimits": "{{label}}: {{temperature}}°C; maximum: {{maximum}}; critical: {{critical}}",
  "cpuMaxTemperature": " · max {{temperature}}°C",
  "memoryDelta": " ({{percent}}% difference)",
  "securitySearchNoMatch": "No active bans match “{{query}}”.",
  "errorAccessDenied": "Access denied.",
  "errorBannedIpsPermission": "You don't have permission to view banned IPs.",
  "errorBannedIps": "Failed to load banned IPs.",
  "errorRemoveBan": "Failed to remove ban.",
  "errorFail2banStatus": "Failed to load fail2ban status.",
  "errorFail2banNetwork": "Network error loading fail2ban status.",
  "errorBanMetrics": "Failed to load ban metrics.",
  "errorBanMetricsNetwork": "Network error loading ban metrics.",
  "securityMostBansWindow": "most bans ({{window}})"
} as const;
